var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoastLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992.55 498.166c0 273.648-221.836 495.484-495.484 495.484s-495.484-221.836-495.484-495.484c0-273.648 221.836-495.484 495.484-495.484s495.484 221.836 495.484 495.484z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M730.234 345.735c95.909 161.326 86.379 346.155-20.325 412.844-3.809 1.906-6.986 4.446-10.798 6.352 39.381-113.69-27.945-244.531-151.162-292.801l-22.231-10.164c-95.272-36.838-156.883-123.217-162.598-212.774-3.174-53.988 38.744-98.448 91.46-97.813 94.637 1.906 203.882 74.312 275.654 194.356zM263.402 651.241c-95.272-160.692-85.745-344.886 20.96-411.576 3.811-1.906 6.987-4.446 10.798-6.351-40.649 113.056 26.676 243.897 149.894 291.532l22.231 10.161c95.272 36.841 156.88 123.22 161.964 212.14 3.174 53.988-38.747 98.449-90.829 97.812-95.272-1.268-203.882-74.309-275.017-193.718z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoastLevel);
export default __webpack_public_path__ + "static/media/icon-roast-level.cf1222ba9bf538da3f5d5d8903af1f28.svg";
export { ForwardRef as ReactComponent };